import type { IconSvgObject } from './types';

const ClipboardPlusIcon: IconSvgObject = [
  ["path", { d: "M16 3.5H18C19.1046 3.5 20 4.39543 20 5.5L20 19.9981C20 21.1027 19.1046 21.9981 18 21.9981L6 21.9981C4.89543 21.9981 4 21.1027 4 19.9981V5.5C4 4.39543 4.89543 3.5 6 3.5L8 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 2H9.5C8.67157 2 8 2.67157 8 3.5C8 4.32843 8.67157 5 9.5 5H14.5C15.3284 5 16 4.32843 16 3.5C16 2.67157 15.3284 2 14.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.0009 10V16M15.0059 12.995L9.00586 12.995", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ClipboardPlusIcon;
